import EFOcats_import_lang from '../../core/v1/import/efocats_import_lang.js';
import EFOcats_import_html from '../../core/v1/import/efocats_import_html.js';
import EFOcats_import_style from '../../core/v1/import/efocats_import_style.js';
import EFOcats_settingdata from '../../core/v1/setting/efocats_settingdata.js';
import EFOcats_making from '../../core/v1/making/efocats_making.js';
import EFOcats_submit from '../../core/v1/submit/efocats_submit.js';
import EFOcats_Validates from '../../core/v1/validate/efocats_validates.js';
import EFOcats_event from '../../core/v1/event/efocats_event.js';

/**
 * EFOcatsコアクラス
 */
export default class EFOcats {
  /**
   * コンストラクタ
   */
  constructor() {
    // 言語ファイル読込み
    EFOcats_import_lang.load(require('../../lang/v1/export-lang-ja.js'));
    EFOcats_import_html.load(require('../../html/v1/export-html.html'));
    EFOcats_import_style.load(require('../../html/v1/export-style.html'));

    // 処理クラスのインスタンスを生成する
    this.settingdata = new EFOcats_settingdata();
    this.submit = new EFOcats_submit();
    this.validations = new EFOcats_Validates();
    this.events = new EFOcats_event();
    this.making = new EFOcats_making();

    // 設定値
    this.rollbackTime = 5000;
    this.AndoroidVer = 7;
    this.iOSVer = 11;

    // フレーム設置先
    this.targetQurey = 'body';

    // 元フォームを取得するためのクエリ
    this.formQuery = '';

    // フォームID
    this.account = {
      id: 0,
      form_id: 0,
    };

    // 許可デバイス(PC/SP)
    this.AllowDevices = ['PC', 'SP'];

    // パスワード関連
    this.pass = {
      min: 0,
      max: 0,
      limit: [],
    };

    // 分岐処理がある場合は設定ファイルを呼び出す
    this.brachSetting = '';
  }

  /**
   * タグ設置した画面の表示時に呼び出される処理
   * @param id ID
   * @param form_id フォームID
   */
  main() {
    try {
      if (!this.check_environment()) {
        this.making.error();
        return;
      }

      this.making.initialize(this.targetQurey);

      // ロードのタイムアウト
      const loadtimeover = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error('Load timed over'));
        }, this.rollbackTime);
      });

      Promise.race([this.making.isLoaded(), loadtimeover]).then(
        data => {
          const rollbackTimer = setTimeout(() => this.rollback(), this.rollbackTime);

          this.settingdata
            .load(this.account.id, this.account.form_id)
            .then(loaddata => {
              const editdata = this.settingdata.edit(loaddata, this.formQuery);

              this.making.build(this.account.id, this.account.form_id, editdata);

              this.submit.initialize();

              this.events.initialize();

              clearTimeout(rollbackTimer);
            })
            .catch((a, b, c) => {
              console.log(a, b, c);
              this.making.error();
            });
        },
        error => {
          console.log(error);
          this.making.error();
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * ロールバック処理
   */
  rollback() {
    this.making.error();

    if (this.intervalList && this.intervalList.length > 0) {
      for (let index = 0; index < this.intervalList.length; index++) {
        clearInterval(this.intervalList[index]);
      }
    }

    console.log('rollback');
  }

  /**
   * 環境チェック
   */
  check_environment() {
    const ua = window.navigator.userAgent.toLowerCase();

    let device = 'PC';

    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      device = 'SP';
    }

    if (efocats.AllowDevices.indexOf(device) < 0) {
      return false;
    }

    if (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1) {
      const version = parseInt(ua.slice(ua.indexOf('android') + 8), 10);

      if (version < this.AndoroidVer) {
        return false;
      }
    } else if (ua.indexOf('iphone os') !== -1) {
      const version = parseInt(ua.slice(ua.indexOf('iphone os') + 10), 10);

      if (version < this.iOSVer) {
        return false;
      }
    }
    return true;
  }

  /**
   * タイマー起動
   * @param {*} func
   * @param {*} delay
   */
  setInterval(func, delay) {
    const id = setInterval(func, delay);

    if (!this.intervalList) this.intervalList = [];

    this.intervalList.push(id);

    return id;
  }

  /**
   * タイマー解除
   * @param {*} id
   */
  clearInterval(id) {
    clearInterval(id);

    const index = this.intervalList.indexOf(id);
    if (index >= 0) {
      this.intervalList.splice(index, 1);
    }
  }
}
